import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick.min.js'
import logosvg from './../../../assets/img/logo.svg'
import logobluepng from './../../../assets/img/logo-blue.png'
import logoblue2xpng from './../../../assets/img/logo-blue@2x.png'
import { fetchAllPlans } from '../../../reducers/itemDetails';
import { displayError } from '../../../reducers/snackbar';
import { setCart } from '../../../reducers/cart';
import { resetCart } from '../../../reducers/cart';
import { displayPrice } from '../../../components/currencyPrice';
import Footer from '../../../components/layout/footer';
import { getTranslation } from '../../../reducers/translation';
import { TRANSLATION_TYPE } from '../../../utils/constants';

function ViewAllPlans() {
    const { plans } = useSelector((state) => state.itemDetails);
    const { currencyCode, planTypes, features, subscribedPlanPeriod } = plans;
    const [planCount, setPlanCount] = useState(0);
    const [displayMonthlyPlan, setDisplayMonthlyPlan] = useState(subscribedPlanPeriod === "Month");
    const [slickIndex, setslickIndex] = useState(0)
    const [hoveredFeature, setHoveredFeature] = useState(null);
    const [slickInitialized, setSlickInitialized] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const t = useSelector(getTranslation)
    const t_label = t[TRANSLATION_TYPE.LABEL] ?? {}
    const t_message = t[TRANSLATION_TYPE.MESSAGE] ?? {}

    const slickSettings = {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        dots: planCount > 1,
        infinite: false,
        mobileFirst: true,
        initialSlide: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="absolute right-full top-[223px] mr-2.5 top-0 h-8 w-8 rounded-full bg-blue-300 text-gray-700 shadow-button-arrow hover:bg-white"><svg class="h-4 w-4 mx-auto"><use href="/img/sprite.svg#arrow-left"></use></svg></button>',
        nextArrow: '<button type="button" class="absolute left-full top-[223px] ml-2.5 top-0 h-8 w-8 rounded-full bg-blue-300 text-gray-700 shadow-button-arrow hover:bg-white"><svg class="h-4 w-4 mx-auto"><use href="/img/sprite.svg#arrow-right"></use></svg></button>',
        responsive: [
            {
                breakpoint: 599,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                    initialSlide: slickIndex,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: planCount > 2
                },
            },
            {
                breakpoint: 767,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                    initialSlide: slickIndex,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: planCount > 3
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                    centerMode: false,
                    centerPadding: '0px',
                    initialSlide: slickIndex,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: planCount > 3
                },
            },
        ]
    };

    const slickTableSettings = {

        arrows: false,
        infinite: false,
        mobileFirst: true,
        initialSlide: slickIndex,
        slidesToShow: Math.min(planCount, 3),
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: Math.min(planCount, 3),
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: Math.min(planCount, 3),
                    slidesToScroll: Math.min(planCount, 3),
                },
            },
        ]
    }

    const slickTableSettings2 = (planCount) => {
        planCount = Math.min(planCount, 3);

        return {
            arrows: false,
            infinite: false,
            mobileFirst: true,
            initialSlide: slickIndex,
            slidesToShow: planCount,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: planCount,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: planCount,
                        slidesToScroll: planCount,
                    },
                },
            ]
        }
    }

    useEffect(() => {
        dispatch(resetCart());

        $('#switcher input').on('change', function () {
            const period = this.value;
            $('[data-' + period + ']').each(function () {
                $(this).text($(this).attr('data-' + period));
            });
        });

        dispatch(fetchAllPlans()).then((response) => {

        }).catch((error) => {
            dispatch(displayError(error));
        })
    }, []);

    useEffect(() => {
        setDisplayMonthlyPlan(subscribedPlanPeriod === "Month")
    }, [subscribedPlanPeriod])

    useEffect(() => {
        updatePlanCount();
    }, [plans])




    const initializeSlick = () => {
        if (planCount <= 0 || slickInitialized)
            return;

        setTimeout(() => {
            destroyCarousel();

            const slickPlans = $('#plans').on('init', function (slick) {
                let minHeight = 0;
                $('.rounded-b-10.bg-gray-0.p-5').each(function () {
                    minHeight = minHeight > $(this).outerHeight() ? minHeight : $(this).outerHeight();
                });
                $('.rounded-b-10.bg-gray-0.p-5').css('min-height', minHeight);

                //updatePlanGroupHeading();
            });

            $('#plans').not('.slick-initialized').slick(slickSettings)
                .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    slickTable.slick('slickGoTo', nextSlide - (window.innerWidth < 600 ? 1 : 0));
                    updatePlanGroupHeadingForNextSlides(currentSlide, nextSlide);
                })

            const slickTable = $('#table')
                .slick(slickTableSettings)
                .on('afterChange', function (event, slick, currentSlide) { })
                .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    slickPlans.slick('slickGoTo', nextSlide);
                    $('#table-prev').attr('disabled', nextSlide == 0);
                    $('#table-next').attr('disabled', nextSlide + 3 >= slick.$slides.length);
                });

            $('#table-prev').on('click', function () {
                slickTable.slick('slickPrev');
            });
            $('#table-next').on('click', function () {
                slickTable.slick('slickNext');
            });

            setSlickInitialized(true);
        }, 0);
    }

    const destroyCarousel = () => {
        if ($('#plans').hasClass('slick-initialized')) {
            $('#plans').slick('unslick');
        }

        if ($('#table').hasClass('slick-initialized')) {
            $('#table').slick('unslick');
        }
    }

    function updatePlanGroupHeading() {
        const planContainer = document.getElementById("plans");

        if (planContainer) {
            const totalSlides = Array.from(planContainer.querySelectorAll('div.slick-slide'));
            var activeSlides = planContainer.querySelectorAll('div.slick-active');
            if (activeSlides.length === 0) {
                // If not, look for elements with the 'slick-current' class
                activeSlides = planContainer.querySelectorAll('div.slick-current');
            }
            var displayedSlideCount = activeSlides.length;

            for (var i = 0; i < totalSlides.length; i += displayedSlideCount) {
                updatePlanGroupHeadingForSlides(totalSlides.slice(i, i + displayedSlideCount));
            }
        }
    }

    function updatePlanGroupHeadingForSlides(slides) {
        let planGroupList = [];
        let prevGroup = "";

        for (var i = 0; i < slides.length; i++) {
            planGroupList.push(slides[i].getAttribute("data-plan-group"))
        }

        for (var i = 0; i < slides.length; i++) {
            var element = slides[i];
            var childElement = element.lastElementChild;
            var currGroup = element.getAttribute("data-plan-group");

            if (prevGroup !== currGroup) {
                childElement.style.display = "block";
            } else {
                childElement.style.display = "none";
            }

            prevGroup = currGroup;
        }
    }

    function updatePlanGroupHeadingForActiveSlides() {
        const planContainer = document.getElementById("plans");

        if (planContainer) {
            var activeSlides = planContainer.querySelectorAll('div.slick-active');
            if (activeSlides.length === 0) {
                // If not, look for elements with the 'slick-current' class
                activeSlides = planContainer.querySelectorAll('div.slick-current');
            }
            var displayedSlideCount = activeSlides.length;
            updatePlanGroupHeadingForSlides(activeSlides);
        }
    }

    function updatePlanGroupHeadingForNextSlides(currentSlide, nextSlide) {
        const planContainer = document.getElementById("plans");
        if (planContainer) {
            const totalSlides = Array.from(planContainer.querySelectorAll('div.slick-slide'));
            var activeSlides = planContainer.querySelectorAll('div.slick-active');
            if (activeSlides.length === 0) {
                // If not, look for elements with the 'slick-current' class
                activeSlides = planContainer.querySelectorAll('div.slick-current');
            }
            var displayedSlideCount = activeSlides.length;

            if (totalSlides.length - nextSlide < displayedSlideCount) {
                nextSlide = totalSlides.length - displayedSlideCount;
            }

            updatePlanGroupHeadingForSlides(totalSlides.slice(nextSlide, nextSlide + displayedSlideCount));
        }
    }

    function updatePlanCount() {
        let planCount_ = 0;

        planTypes && planTypes?.map((planGroup) => {
            planCount_ += planCountInGroup(planGroup);
        });
        setPlanCount(planCount_);
    }

    const handlePlanPeriodChange = (isMonthlyPlan) => {
        setDisplayMonthlyPlan(isMonthlyPlan);

        updateSlickIndex();
        if (checkForMissingItemPrice())
            destroyCarousel();
        setTimeout(() => {
            updatePlanGroupHeadingForActiveSlides();
        }, 10);
    }

    const updateSlickIndex = () => {
        const currentElement = $('.slick-current');
        if (currentElement.length > 0) {
            const slickIndex = currentElement.data('slick-index');
            setslickIndex(slickIndex);
        }
    }

    const checkForMissingItemPrice = () => {
        let flag = true;

        let plans_ = plans?.planTypes;

        if (plans_ && plans_.length > 0) {
            plans_.map((plan) => {
                if (plan?.plans) {
                    plan.plans.map((plan_) => {
                        let itemPrices = plan_?.itemPrices ?? [];
                        let itemPrices_ = itemPrices.filter((itemPrice) => {
                            return (itemPrice.period === 1 && ["Month", "Year"].includes(itemPrice.periodUnit))
                        });
                        flag = flag && itemPrices.length === 2 && itemPrices_.length === 2;
                    })
                }
            })
        }

        return !flag;
    }

    const getPeriodText = (period, periodUnit) => {
        if (period === 1) {
            return periodUnit.toLowerCase();
        } else if (period > 1) {
            return `${period} ${periodUnit.toLowerCase()}s`
        }
    }

    const navigateToCheckout = (event) => {
        const button = event.target.closest("button");
        if (button) {
            const itemPriceId = button.id;
            dispatch(setCart({ count: 1, "items": { "0": { "item": itemPriceId } } }));
            navigate("/checkout/viewBillingDetails");

        }
    }

    const displayPlan = (plan, itemPrice, planType, index, planCount) => {
        const description = plan.name ?? plan.description;
        const price = itemPrice?.amount;
        const isPlanPresent = itemPrice != null;
        const subscribed = itemPrice.isSelected;
        const colorStyleClass = subscribed ? "text-gray-550" : "text-green-text";
        const displayGroupHeading = planCount >= 3 ? index % 3 === 0 : index % planCount === 0;
        const remainingPlan = planCount - index;
        const borderWidth = remainingPlan >= 3 ? 300 : remainingPlan * 100;

        if (!isPlanPresent) {
            return <></>
        }
        return <>
            <div id={plan.id} data-plan-group={planType} class="relative px-1 pt-14 sm:px-2.5">
                <div class="relative overflow-hidden rounded-t-10 bg-white p-5 pt-4 sm:text-center lg:p-7 lg:pt-5">
                    <div class="flex h-9 items-center text-lg font-extrabold uppercase text-gray-900 sm:justify-center">{description}</div>
                    <div class={`mt-1.5 text-h1 text-[40px] font-extrabold ${colorStyleClass}`}>{displayPrice(price, currencyCode)}</div>
                    <div class="text-h2 font-bold text-gray-550">/{t_label?.['billing.label.month'] ?? 'month'}</div>

                    {subscribed ?
                        <div class="mt-4 flex h-[50px] w-full items-center justify-center gap-2 rounded-md bg-gray-100 text-gray-400 ring-1 ring-inset ring-gray-300">
                            <span class="text-h1">{t_label?.['billing.label.subscribed'] ?? 'Subscribed'}</span>
                            <svg class="-mt-0.5 h-6 w-6"><use href="/img/sprite.svg#check-double"></use></svg>
                        </div>
                        :
                        <button id={itemPrice.id} onClick={(e) => navigateToCheckout(e)} type="button" class="mt-4 flex h-[50px] w-full items-center justify-center gap-2 rounded-md bg-gradient-to-b from-blue-600 to-blue-800 px-3 text-white shadow-button hover:shadow-button-hover active:shadow-button-active">
                            <span class="text-h1">{t_label?.['billing.label.select_plan'] ?? 'Select Plan'}</span>
                        </button>
                    }

                </div>
                <div class="rounded-b-10 bg-gray-0 p-5 lg:p-7 lg:pt-5">
                    {displayPlanMeta(plan, itemPrice)}

                </div>


                <div style={{ 'display': displayGroupHeading ? 'block' : 'none' }} class={`absolute left-0.5 top-0 mb-6 w-[calc(${borderWidth}%-8px)] border-b border-gray-550 sm:left-2.5 sm:w-[calc(${borderWidth}%-20px)]`}>
                    <div class="pb-2 text-xl font-bold text-white">{planType.replace("_", " ")} Plan</div>
                </div>

            </div>
        </>
    }

    const displayPlanMeta = (plan, itemPrice) => {
        const header = plan?.meta?.header;
        const features = plan?.meta?.data;
        const subscribed = itemPrice.isSelected;
        const checkStyleClass = subscribed ? "" : "text-green";

        return <>
            {
                header &&
                <div class="font-extrabold text-md" dangerouslySetInnerHTML={{ __html: header }} />
            }

            {
                features && features.map((data) => {
                    return <>
                        {
                            <div class="mt-2 flex items-start gap-1.5">
                                <svg class={`h-4 w-4 shrink-0 ${checkStyleClass}`}><use href="/img/sprite.svg#check"></use></svg>
                                <div class="text-sm" dangerouslySetInnerHTML={{ __html: data.header }} />
                            </div>
                        }

                        {
                            data?.data && data?.data.map((data_) => {
                                return <>
                                    <div class="mt-1 ml-1.5 flex items-start gap-1.5 pl-4">
                                        <svg class="h-4 w-3 shrink-0"><circle cx="6" cy="8" r="1.5" /></svg>
                                        <div class="text-sm" dangerouslySetInnerHTML={{ __html: data_ }} />
                                    </div>
                                </>
                            })
                        }
                    </>
                })
            }
        </>
    }

    const planCountInGroup = (planGroup) => {
        const plans = planGroup.plans;
        let count = 0;
        for (let i = 0; i < plans.length; i++) {
            const itemPrices = plans[i]?.itemPrices.filter((itemPrice) => (itemPrice.periodUnit === (displayMonthlyPlan ? "Month" : "Year")));
            count += itemPrices.length;
        }
        return count;
    }

    const displayAllPlans = () => {
        const planTypes = plans?.planTypes;
        return <>
            {
                planTypes && planTypes?.map((planGroup) => {
                    let planCount = planCountInGroup(planGroup);
                    let currentCount = 0;
                    return <>
                        {

                            planGroup?.plans && planGroup?.plans.map((plan, index) => {
                                const itemPrices = plan?.itemPrices.filter((itemPrice) => (itemPrice.periodUnit === (displayMonthlyPlan ? "Month" : "Year")));

                                if (itemPrices != null) {
                                    return itemPrices.map((itemPrice) => {
                                        return displayPlan(plan, itemPrice, planGroup.name, currentCount++, planCount);
                                    })
                                }
                            })
                        }
                    </>
                })
            }

            {
                planTypes && planTypes.length > 0 && initializeSlick()
            }
        </>
    }

    const displayPlanFeatures = () => {
        return <>
            <div class="text-md absolute top-[115px] right-0 left-0 lg:top-[147px] lg:right-1/2 lg:rounded-l-md lg:border lg:border-r-0 lg:border-gray-300/50">
                {
                    features.map((feature, index) => {
                        return <div class={`mt-8 flex h-10 items-center px-4 font-bold leading-none text-gray-1000 lg:mt-0 lg:px-2.5  ${hoveredFeature === index ? 'bg-blue-200' : 'lg:even:bg-gray-0'}`}
                            onMouseEnter={() => setHoveredFeature(index)}
                            onMouseLeave={() => setHoveredFeature(null)}
                        >
                            {feature}
                        </div>
                    })
                }

            </div >
        </>
    }

    const displayPlanFeaturesValues = (featureValues) => {
        return <>
            {
                featureValues.map((value, index) => {
                    return featureValueStyle(value, index)
                })
            }
        </>
    }

    const featureValueStyle = (featureValue, index) => {

        if (featureValue === "true") {
            return <div class={`mt-10 border-l border-gray-300/50 bg-gray-0 p-2 text-center text-sm text-gray-1000 lg:mt-0 lg:py-3  ${hoveredFeature === index ? 'bg-blue-200' : 'lg:odd:bg-transparent'}`}
                onMouseEnter={() => setHoveredFeature(index)}
                onMouseLeave={() => setHoveredFeature(null)}
            >
                <svg class="mx-auto h-4 w-4 text-green"><use href="/img/sprite.svg#check"></use></svg>
            </div>
        } else if (featureValue === "false") {
            return <div class={`mt-10 border-l border-gray-300/50 bg-gray-0 p-2 text-center text-sm text-gray-1000 lg:mt-0 lg:py-3   ${hoveredFeature === index ? 'bg-blue-200' : 'lg:odd:bg-transparent'}`}
                onMouseEnter={() => setHoveredFeature(index)}
                onMouseLeave={() => setHoveredFeature(null)}
            >
                <svg class="mx-auto h-4 w-4 text-gray-500"><use href="/img/sprite.svg#close"></use></svg>
            </div>
        }
        else if (typeof featureValue === 'string') {
            return <div class={`mt-10 border-l border-gray-300/50 bg-gray-0 p-2 text-center text-sm text-gray-1000 lg:mt-0 lg:py-3   ${hoveredFeature === index ? 'bg-blue-200' : 'lg:odd:bg-transparent'}`}
                onMouseEnter={() => setHoveredFeature(index)}
                onMouseLeave={() => setHoveredFeature(null)}
            >
                {featureValue}
            </div>
        } else return <></>
    }

    const displayPlanSettings = (plan, itemPrice) => {
        const description = plan.name ?? plan.description;
        const price = itemPrice?.amount;
        const isPlanPresent = itemPrice != null;
        const subscribed = itemPrice.isSelected;
        const header = plan?.meta?.header;
        const features = plan?.meta?.data;
        const colorStyleClass = subscribed ? "text-gray-550" : "text-green-text";
        const checkStyleClass = subscribed ? "" : "text-green";

        return <>
            <div class="dark">
                <div class="flex h-18 items-center justify-center border-l border-gray-300/50 bg-gray-300/50">
                    <div class="px-1.5 text-sm font-extrabold uppercase text-gray-1000">{description}</div>
                </div>
                <div class="border-l border-b border-gray-300/50 bg-gray-100 p-3">
                    <div class="flex items-baseline justify-center gap-1 text-green-text"><span data-monthly="$4.99" data-annual="$3.99" class="text-lg text-gray-900">{displayPrice(price, currencyCode)}</span><span class="text-sm text-gray-500">/{t_label?.['billing.label.month'] ?? 'month'}</span></div>

                    {
                        subscribed ?

                            <div class="mx-auto mt-1.5 flex h-[26px] w-full max-w-[160px] items-center justify-center gap-1 text-gray-500">
                                <div class="text-xxs font-extrabold uppercase">{t_label?.['billing.label.subscribed'] ?? 'Subscribed'}</div>
                                <svg class="-mt-0.5 h-3 w-3"><use href="/img/sprite.svg#check-double"></use></svg>
                            </div>

                            :

                            <button type="button" id={itemPrice.id} onClick={(e) => navigateToCheckout(e)} class="mx-auto mt-1.5 flex h-[26px] w-full max-w-[160px] items-center justify-center gap-1 rounded-md bg-gradient-to-b from-blue-600 to-blue-800 text-sm font-bold text-white shadow-button hover:shadow-button-hover active:shadow-button-active disabled:bg-gray-700 disabled:bg-none disabled:text-gray-500 disabled:shadow-none dark:bg-blue-600 dark:bg-none dark:shadow-none dark:hover:bg-blue-800 dark:active:bg-blue-900 dark:disabled:bg-gray-300 dark:disabled:text-gray-400">
                                <span>{t_label?.['billing.button.upgrade_now'] ?? 'Upgrade Now'}</span>
                            </button>
                    }

                </div>

                {
                    displayPlanFeaturesValues(plan.featureValues)
                }

            </div>
        </>
    }

    const displayPlanSettingsTable = () => {

        const planTypes = plans?.planTypes;

        return <>
            <div class="overflow-hidden lg:ml-auto lg:w-1/2 lg:rounded-md lg:rounded-bl-none lg:border lg:border-gray-300/50 xl:w-[calc(50%-20px)]">
                <div id="table" class="-ml-px text-center">
                    {
                        planTypes && planTypes?.map((planGroup) => {
                            return <>
                                {
                                    planGroup?.plans && planGroup?.plans.map((plan) => {
                                        const itemPrices = plan?.itemPrices.filter((itemPrice) => (itemPrice.periodUnit === (displayMonthlyPlan ? "Month" : "Year")));

                                        if (itemPrices != null) {
                                            return itemPrices.map((itemPrice) => {
                                                return displayPlanSettings(plan, itemPrice);
                                            })
                                        }
                                    })
                                }
                            </>
                        })
                    }

                    {
                        planTypes && planTypes.length > 0 && initializeSlick()
                    }
                </div>
            </div>

            <div class="absolute top-18 right-1/2 mr-4 hidden h-[75px] items-center xl:flex">
                <button type="button" disabled id="table-prev" class="flex h-6 w-6 items-center justify-center rounded-full bg-blue-300 text-gray-700 shadow-button-arrow hover:bg-white disabled:hidden dark:bg-gray-1000/80 dark:text-white dark:shadow-button-arrow-dark dark:hover:bg-gray-1000">
                    <svg class="h-4 w-4"><use href="/img/sprite.svg#arrow-left"></use></svg>
                </button>
            </div>
            <div class="absolute top-18 right-0 hidden h-[75px] items-center xl:flex">
                <button type="button" disabled={planCount < 3} id="table-next" class="flex h-6 w-6 items-center justify-center rounded-full bg-blue-300 text-gray-700 shadow-button-arrow hover:bg-white disabled:hidden dark:bg-gray-1000/80 dark:text-white dark:shadow-button-arrow-dark dark:hover:bg-gray-1000">
                    <svg class="h-4 w-4"><use href="/img/sprite.svg#arrow-right"></use></svg>
                </button>
            </div>
        </>
    }

    const mainWidth = () => {
        if (planCount >= 3)
            return "max-w-[1320px]";
        else if (planCount < 3)
            return "max-w-[1040px]"
    }

    return (
        <>
            <div class={`dark bg-white`}>
                <header class="flex items-center justify-between px-5 py-4">
                    <a onClick={() => navigate("/billing")} class="flex items-center justify-center gap-1 hover:text-blue-600 cursor-pointer">
                        <svg class="h-4 w-4"><use href="/img/sprite.svg#arrow-left"></use></svg>
                        <span>{t_label?.['billing.button.back_to_billing'] ?? 'Back to Billing'}</span>
                    </a>

                    <a onClick={() => navigate("/billing")} class="flex items-center gap-2 align-top">
                        <div class="h-6 w-6 overflow-hidden">
                            <img src={logosvg} width="26" height="26" alt="" class="-m-px max-w-none" />
                        </div>
                        <img src={logobluepng} srcset={`${logoblue2xpng} 2x`} width="98" height="20" alt="" />
                    </a>
                </header>

                <main class={`m-auto w-full ${mainWidth()} p-5 py-10`}>

                    <div class="relative mx-auto max-w-[1080px]">
                        <div class="absolute -top-10 left-1/2 h-[514px] w-screen -translate-x-1/2 bg-gray-800 sm:h-[503px] lg:h-[515px]"></div>

                        <div class="relative text-center">
                            <div class="text-xs font-extrabold text-gray-300">{t_message?.['billing.message.grow_your_portfolio'] ?? 'GROW YOUR PORTFOLIO WITH VECTORVEST'}</div>
                            <h1 class="mt-2 text-h1xl text-[40px] text-white sm:text-[48px]">{t_label?.['billing.label.select_your_plan'] ?? 'Select Your Plan'}</h1>
                            {
                                subscribedPlanPeriod === "Month" && <>
                                    <div class="mx-auto mt-3 grid w-44 grid-cols-2 rounded-md bg-gray-600 p-0.5 text-gray-300">
                                        <label class="relative cursor-pointer hover:text-white">
                                            <input type="radio" name="plan-period" value="monthly" defaultChecked class="peer absolute top-0 left-0 h-0 w-0 appearance-none" onClick={() => handlePlanPeriodChange(true)} />
                                            <span class="block rounded p-0.5 peer-checked:bg-gradient-to-b peer-checked:from-blue-600 peer-checked:to-blue-800 peer-checked:text-white peer-checked:shadow-button">{t_label?.['checkout.label.monthly'] ?? 'Monthly'}</span>
                                        </label>
                                        <label class="relative cursor-pointer hover:text-white">
                                            <input type="radio" name="plan-period" value="annual" class="peer absolute top-0 left-0 h-0 w-0 appearance-none" onClick={() => handlePlanPeriodChange(false)} />
                                            <span class="block rounded p-0.5 peer-checked:bg-gradient-to-b peer-checked:from-blue-600 peer-checked:to-blue-800 peer-checked:text-white peer-checked:shadow-button">{t_label?.['checkout.label.annual'] ?? 'Annual'}</span>
                                        </label>
                                    </div>
                                    <div class="relative mt-4 text-xl text-white">
                                        <svg width="29" height="32" viewBox="0 0 29 32" fill="#FEBE2B" stroke="#FEBE2B" stroke-width="0.5" class="absolute bottom-full left-1/2 ml-24">
                                            <path
                                                d="M14.5785 15.8002L14.5765 15.7998C13.5027 15.5515 12.6721 15.7666 12.0644 16.2814L12.0642 16.2815C11.2191 16.9984 10.8972 18.3127 11.0623 19.5365C11.2216 20.7525 11.8447 21.9635 12.8781 22.5361C13.5916 22.9393 14.4888 23.0215 15.5194 22.6087C16.7126 22.1382 17.3857 21.145 17.7089 19.993C17.7952 19.7033 17.8487 19.4135 17.8853 19.1212C18.0972 19.2987 18.3104 19.4776 18.5251 19.6585C19.583 20.6107 20.5697 21.7185 21.4189 22.8632L21.4209 22.8658C22.5591 24.3583 23.4065 25.9841 23.9579 27.7766L23.961 27.7866L23.9649 27.7962C24.0735 28.0669 24.3795 28.2336 24.6746 28.1457L24.6749 28.1456C24.9814 28.0539 25.1287 27.734 25.057 27.4454L25.0574 27.4453L25.0532 27.4318C24.46 25.5122 23.5596 23.7618 22.3382 22.1654L22.3376 22.1645C21.4272 20.9853 20.4095 19.7997 19.2728 18.8042L19.2728 18.8041L19.2706 18.8023C18.8315 18.4264 18.3948 18.0548 17.9444 17.701C17.9009 16.7371 17.7141 15.797 17.4705 15.0578L17.4705 15.0578L17.4691 15.0539C16.5866 12.5194 14.6031 10.3593 12.2777 8.59975C9.95014 6.83849 7.25868 5.46219 4.92361 4.50077C4.63571 4.37715 4.31054 4.51008 4.18928 4.80017L4.18915 4.80047C4.06425 5.10036 4.22017 5.42115 4.49444 5.54048L4.49442 5.54053L4.49889 5.54237C6.73339 6.4636 9.30645 7.76734 11.5234 9.43026C13.7433 11.0954 15.5841 13.1041 16.3905 15.429C16.5324 15.8382 16.6491 16.3328 16.7258 16.8611C16.7217 16.8585 16.7177 16.8559 16.7136 16.8533C16.0961 16.46 15.3507 15.9853 14.5785 15.8002L14.5785 15.8002ZM16.2154 17.8818L16.2153 17.8819L16.2202 17.8847C16.4303 18.0042 16.626 18.1355 16.808 18.2789C16.8038 18.7587 16.7451 19.2352 16.6128 19.6837L16.6127 19.6836L16.6111 19.6895C16.3837 20.536 15.9125 21.2322 15.0888 21.5615C14.4072 21.8307 13.8633 21.7727 13.4356 21.5366L13.4356 21.5365L13.4321 21.5347C12.743 21.1682 12.3147 20.3092 12.1977 19.3832L12.1977 19.3831L12.1971 19.3787C12.0666 18.4778 12.2694 17.5979 12.8141 17.1362C13.1373 16.8625 13.6213 16.7347 14.324 16.8989C14.6367 16.9789 14.9518 17.1281 15.2711 17.3086C15.4718 17.422 15.662 17.5403 15.8527 17.659C15.9724 17.7335 16.0924 17.8082 16.2154 17.8818Z"
                                            />
                                            <path
                                                d="M11.3428 3.69157C11.4611 3.97942 11.3207 4.31688 11.0317 4.42766C9.53573 5.02705 7.63879 5.16399 6.09765 5.26115C5.94484 5.27249 5.77101 5.25808 5.60179 5.23907C5.52424 5.23037 5.45034 5.22107 5.37662 5.2118C5.27613 5.19917 5.17596 5.18657 5.06728 5.17555L5.06237 5.17505L5.06238 5.175C5.01889 5.16972 4.97709 5.1647 4.93694 5.1602C5.01345 5.3262 5.10344 5.49845 5.18693 5.64875C5.24559 5.75432 5.29989 5.84701 5.34226 5.91643C5.38256 5.98247 5.40492 6.01552 5.41006 6.02312C5.41094 6.02441 5.41131 6.02497 5.4112 6.02483L5.42871 6.04593L5.44123 6.07033C6.05121 7.25872 6.52359 8.42522 6.15877 9.865C6.0903 10.1727 5.76556 10.3542 5.46853 10.2805L5.45272 10.2766L5.43755 10.2707C5.1884 10.1731 4.99703 9.89206 5.06048 9.59359L5.06273 9.58302L5.06296 9.58308C5.34335 8.49709 4.95299 7.63958 4.42626 6.59373L4.42594 6.5931L4.42594 6.5931L4.42594 6.59309C4.42591 6.59304 4.42566 6.59254 4.42511 6.5915L4.42275 6.58704L4.41471 6.57227L4.38859 6.52543C4.38084 6.51162 4.37198 6.49588 4.36224 6.47859C4.34576 6.44931 4.32677 6.41557 4.30639 6.37918C4.24086 6.26219 4.15666 6.1101 4.0705 5.9464C3.90394 5.62992 3.71119 5.23556 3.64988 4.97142L3.64847 4.96534L3.64855 4.96532C3.56328 4.55134 3.74145 4.22159 4.01057 4.11856C4.2946 3.99572 4.64508 3.99376 4.97669 4.02158L4.98405 4.0222L4.98404 4.02231C5.095 4.03493 5.21721 4.05137 5.33558 4.06729C5.41609 4.07812 5.49482 4.0887 5.56702 4.09769C5.75487 4.12107 5.9103 4.1353 6.01917 4.13163M11.3428 3.69157C11.3428 3.69161 11.3428 3.69164 11.3429 3.69168L11.1116 3.78658L11.3428 3.69157ZM11.3428 3.69157C11.2293 3.41498 10.9151 3.24741 10.5997 3.3804M10.5997 3.3804C9.30299 3.89405 7.63541 4.01469 6.15065 4.12211C6.10666 4.12529 6.06282 4.12847 6.01917 4.13163M10.5997 3.3804C10.6007 3.38004 10.6016 3.37968 10.6025 3.37931L10.6947 3.6117M10.5997 3.3804C10.5985 3.38091 10.5973 3.38142 10.5961 3.38194L10.6947 3.6117M6.01917 4.13163C6.02052 4.13159 6.02186 4.13154 6.0232 4.13149L6.03272 4.38131M6.01917 4.13163C6.01765 4.13174 6.01613 4.13186 6.01462 4.13197L6.03272 4.38131M6.03272 4.38131C6.08346 4.37762 6.13449 4.37394 6.18581 4.37023C7.65805 4.26385 9.36083 4.14082 10.6947 3.6117M6.03272 4.38131C5.84662 4.3884 5.57332 4.35159 5.29664 4.31431C5.1816 4.29881 5.06597 4.28324 4.95579 4.27071C4.6271 4.24313 4.32827 4.25159 4.10444 4.35037L10.6947 3.6117"
                                            />
                                        </svg>
                                        <div dangerouslySetInnerHTML={{ __html: t_message?.['billing.message.get_x_months_free_with_annual_plan'] ?? 'Get 2 Months FREE with an Annual Plan <nobr>(Save up to $293)</nobr>' }} />
                                    </div>
                                </>
                            }

                        </div>

                        <div id="plans" class="-mx-5 mt-12 lg:mx-0">
                            {displayAllPlans()}
                        </div>

                    </div>

                    {
                        plans.planTypes && plans.planTypes.length > 0 &&
                        <div class="relative -mx-5 mt-15 overflow-hidden lg:mx-0 xl:pr-10">

                            {
                                displayPlanFeatures()
                            }
                            {
                                displayPlanSettingsTable()
                            }

                        </div>
                    }
                </main>

                <Footer />
            </div>
        </>
    )
}

export default ViewAllPlans;